export default {
    name: "DocumentPreview",
    props: {
        selected_template: {
            type: Object,
            default: null
        },
        template_bindings: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        load_error: {
            type: String,
            default: ''
        }
    },
    emits: ['update:selected_template', 'continue'],
    computed: {
        selected_template_id() {
            return this.selected_template?.id != null ? String(this.selected_template.id) : '';
        },
        selected_template_name() {
            return this.selected_template?.name || '';
        },
        selected_template_url() {
            return this.selected_template?.presigned_url || this.selected_template?.url || '';
        },
        selected_template_type_label() {
            return this.selected_template?.type
                ? String(this.selected_template.type).toUpperCase()
                : 'PDF';
        }
    },
    methods: {
        on_template_change(event) {
            const selected_id = String(event?.target?.value || '');
            const selected_template = (this.template_bindings || []).find(
                (binding) => String(binding?.id) === selected_id
            ) || null;

            this.$emit('update:selected_template', selected_template);
        }
    }
}
